export function mergeTiles(one, two) {
    const result = one;

    for(const zoom in two) {
        if (!two.hasOwnProperty(zoom)) continue;

        if (!result[zoom]) result[zoom] = [];

        for(const x in two[zoom]) {
            if (!two[zoom].hasOwnProperty(x)) continue;

            if (!result[zoom][x]) result[zoom][x] = [];

            for(const y in two[zoom][x]) {
                if (!two[zoom][x].hasOwnProperty(y)) continue;

                result[zoom][x][y] = two[zoom][x][y];
            }
        }
    }

    return result;
}

export function getMapDefaults(gmapsObj) {
    const chicago = new gmapsObj.LatLng(41.850033, -87.6500523);
    return {
        zoom: 5,
        maxZoom: 9,
        minZoom: 1,
        center: chicago,
        zIndex: 1500,
    };
}

export function getDrawingDefaults(gmapsObj) {
    return {
        drawingMode: gmapsObj.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
            position: gmapsObj.ControlPosition.TOP_CENTER,
            drawingModes: [
                gmapsObj.drawing.OverlayType.POLYGON,
                gmapsObj.drawing.OverlayType.RECTANGLE,
            ],
        },
        polygonOptions: {
            fillColor: '#0000ff',
            fillOpacity: 0.7,
            strokeWeight: 1,
            clickable: false,
            zIndex: 2000,
            editable: false,
        },
        rectangleOptions: {
            fillColor: '#0000ff',
            fillOpacity: 0.7,
            strokeWeight: 1,
            clickable: false,
            zIndex: 2000,
            editable: false,
        },
    };
}

export function getNormalizedCoord(coord, zoom) {
    const y = coord.y;
    let x = coord.x;

    // tile range in one direction range is dependent on zoom level
    // 0 = 1 tile, 1 = 2 tiles, 2 = 4 tiles, 3 = 8 tiles, etc
    const tileRange = 1 << zoom;

    // don't repeat across y-axis (vertically)
    if (y < 0 || y >= tileRange) {
        return null;
    }

    // repeat across x-axis
    if (x < 0 || x >= tileRange) {
        x = (x % tileRange + tileRange) % tileRange;
    }

    return { x, y };
}
